module.exports = __webpack_public_path__ + "static/media/menu_usuarios_do_sistema.10b25e5f.png";